<template>
  <div>
    <div class="pickr-container" />
  </div>
</template>

<script>
import _ from 'lodash'
import Pickr from '@simonwep/pickr'
import '@simonwep/pickr/dist/themes/nano.min.css'

const pickerConfig = {
  swatches: [
    'rgba(244, 67, 54, 1)',
    'rgba(233, 30, 99, 1)',
    'rgba(156, 39, 176, 1)',
    'rgba(103, 58, 183, 1)',
    'rgba(63, 81, 181, 1)',
    'rgba(33, 150, 243, 1)',
    'rgba(3, 169, 244, 1)',
    'rgba(0, 188, 212, 1)',
    'rgba(0, 150, 136, 1)',
    'rgba(76, 175, 80, 1)',
    'rgba(139, 195, 74, 1)',
    'rgba(205, 220, 57, 1)',
    'rgba(255, 235, 59, 1)',
    'rgba(255, 193, 7, 1)',
  ],

  components: {
    preview: true,
    opacity: true,
    hue: true,

    interaction: {
      hex: false,
      rgba: false,
      input: true,
      hsva: false,
      clear: false,
    },
  },
}

export default {
  props: {
    currentColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pickr: null,
    }
  },
  watch: {
    currentColor(val) {
      if (this.pickr && val) {
        this.pickr.setColor(val)
      }
    },
  },
  destroyed() {
    if (this.pickr) {
      this.pickr.destroyAndRemove()
    }
  },
  mounted() {
    const pickrContainer = this.$el.querySelector('.pickr-container')
    const self = this
    const el = document.createElement('p')
    pickrContainer.appendChild(el)

    // Delete previous instance
    if (this.pickr) {
      this.pickr.destroyAndRemove()
    }

    // Create fresh instance
    this.pickr = new Pickr({
      el,
      theme: 'nano',
      default: this.currentColor || '#4af',
      ...pickerConfig,
    })

    this.pickr.on('change', async (color) => {
      const hex = color.toHEXA().toString()
      this.pickr.setColor(hex)
      this.changeColor(hex)
    })
    this.pickr.on('changestop', () => {
      self.$emit('stopChangingColor', this.pickr.getColor().toHEXA().toString())
    })
  },

  methods: {
    changeColor: _.throttle(function debounceChangeColor(color) {
      this.$emit('changeColor', color)
    }, 500, { leading: true, trailing: true }),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/style.scss";

.pickr-container {
  &.active {
    & ::v-deep .pickr .pcr-button {
      border: 1px solid $primary-color !important;
      box-shadow: 0 0 0 2px $primary-color !important;
    }
  }
  &:not(.active) {
    & ::v-deep .pickr .pcr-button::after {
      @apply border border-solid border-base-30;
    }
  }
}
</style>
